<div class="kiene-content-page wareneingang-page" [class.is-scanning]="!!scanFile">
    <input #pdfPicker accept="application/pdf" hidden type="file" (change)="onPdfPicked($event)" />

    <h1 color="primary">Wareneingang</h1>

    <div
        *ngIf="!scanFile"
        class="drop-zone"
        kieneDropFile
        tabindex="0"
        (click)="openPdfPicker()"
        (keyup.enter)="openPdfPicker()"
        (onFileDropped)="onPdfDropped($event)"
    >
        <mat-icon class="drop-zone__icon">picture_as_pdf</mat-icon>
        <div class="drop-zone__title">Lieferschein-PDF hierher ziehen</div>
        <div class="drop-zone__hint">Artikel, Mengen und Bestellung(en) werden erkannt und der Lieferschein hinterlegt</div>
        <div class="drop-zone__formats">PDF</div>
        <button mat-stroked-button type="button" color="primary" class="drop-zone__pick" (click)="openPdfPicker(); $event.stopPropagation()">
            Datei auswählen
        </button>
    </div>

    <div *ngIf="scanFile" class="scan-layout">
        <div class="pdf-pane">
            <div class="pdf-toolbar">
                <span class="pane-title">Lieferschein</span>
                <button mat-icon-button type="button" (click)="prevPdfPage()" [disabled]="pdfPage <= 1">
                    <mat-icon>navigate_before</mat-icon>
                </button>
                <span>{{ pdfPage }} / {{ pdfPages || '…' }}</span>
                <button
                    mat-icon-button
                    type="button"
                    (click)="nextPdfPage()"
                    [disabled]="!pdfPages || pdfPage >= pdfPages"
                >
                    <mat-icon>navigate_next</mat-icon>
                </button>
                <span class="spacer"></span>
                <button mat-icon-button type="button" (click)="clearScan()" matTooltip="Scan verwerfen">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
            <div class="pdf-stage">
                <div class="pdf-loading" *ngIf="pdfLoading">PDF wird geladen …</div>
                <pdf-viewer
                    *ngIf="pdfSrc"
                    [src]="pdfSrc"
                    [page]="pdfPage"
                    [show-all]="false"
                    [render-text]="true"
                    [original-size]="false"
                    [fit-to-page]="true"
                    [autoresize]="true"
                    [zoom-scale]="'page-fit'"
                    (after-load-complete)="onPdfLoad($event)"
                ></pdf-viewer>
            </div>
        </div>

        <div class="form-pane">
            <div class="scan-status" *ngIf="scanning">
                <mat-spinner diameter="32"></mat-spinner>
                <div>
                    <strong>Lieferschein wird gelesen …</strong>
                    <p>Artikel und Bestellung werden zugeordnet.</p>
                </div>
            </div>

            <div class="scan-error" *ngIf="scanFailed && !scanning">
                <mat-icon>warning</mat-icon>
                <div>
                    <strong>Scan nicht möglich</strong>
                    <p>{{ scanError }}</p>
                    <button mat-stroked-button type="button" color="primary" (click)="clearScan()">Manuell buchen</button>
                </div>
            </div>

            <ng-container *ngIf="!scanning && !scanFailed && draft">
                <div class="scan-head">
                    <button
                        mat-stroked-button
                        type="button"
                        (click)="setScanKind('lieferschein')"
                        [color]="scanKind === 'lieferschein' ? 'accent' : null"
                    >
                        Lieferschein
                    </button>
                    <button
                        mat-stroked-button
                        type="button"
                        (click)="setScanKind('rechnung')"
                        [color]="scanKind === 'rechnung' ? 'accent' : null"
                    >
                        Rechnung
                    </button>
                    <button
                        type="button"
                        class="kind-chip"
                        [class.warn]="scanKind !== 'lieferschein' || ocrFailed"
                        matTooltip="JSON kopieren"
                        (click)="copyScanJson()"
                    >
                        {{ scanKindLabel }}
                        <mat-icon class="kind-chip__copy">content_copy</mat-icon>
                    </button>
                    <button
                        *ngIf="scanWarnings.length"
                        mat-icon-button
                        type="button"
                        class="scan-info-btn"
                        [class.open]="scanInfoOpen"
                        [matTooltip]="scanInfoOpen ? 'Scan-Infos ausblenden' : 'Scan-Infos'"
                        (click)="scanInfoOpen = !scanInfoOpen"
                    >
                        <mat-icon>info_outline</mat-icon>
                    </button>
                </div>
                <div class="scan-info" *ngIf="scanInfoOpen && scanWarnings.length">
                    <p *ngFor="let w of scanWarnings">{{ w }}</p>
                </div>

                <h4 class="pane-heading">Lieferant</h4>
                <kiene-autocomplete
                    [apiUrl]="'lieferant/'"
                    [displayField]="'bezeichnung'"
                    [kieneObject]="scanLieferant"
                    [placeholder]="'Lieferant suchen'"
                    [focus]="false"
                    (elementSelected)="setScanLieferant($event)"
                ></kiene-autocomplete>
                <p class="meta" *ngIf="draft.suggestedRechnungNr || draft.suggestedDatum">
                    <span *ngIf="draft.suggestedRechnungNr">Nr. {{ draft.suggestedRechnungNr }}</span>
                    <span *ngIf="draft.suggestedRechnungNr && draft.suggestedDatum"> · </span>
                    <span *ngIf="draft.suggestedDatum">{{ draft.suggestedDatum }}</span>
                </p>

                <h4 class="pane-heading">Offene Bestellung</h4>
                <p class="hint" *ngIf="scanOrders.length > 1">
                    {{ scanSelectedOrders.length }} von {{ scanOrders.length }} Bestellungen ausgewählt
                </p>
                <mat-chip-list *ngIf="scanOrders.length" class="order-chips" [multiple]="true">
                    <mat-chip
                        *ngFor="let po of scanOrders"
                        class="order-chip"
                        [class.is-on]="isScanOrderSelected(po)"
                        (click)="toggleScanOrder(po)"
                    >
                        {{ scanOrderLabel(po) }}
                    </mat-chip>
                </mat-chip-list>
                <p class="hint" *ngIf="scanOrderHint">{{ scanOrderHint }}</p>

                <h4 class="pane-heading">Positionen vom {{ scanKindLabel }}</h4>
                <p class="hint" *ngIf="!scanLines.length">Keine Positionen erkannt – unten hinzufügen.</p>
                <p class="hint" *ngIf="ocrHadNoLines && scanLines.length">
                    Positionen aus {{ scanSelectedOrders.length === 1 ? 'der gewählten Bestellung' : 'den gewählten Bestellungen' }}.
                </p>
                <div class="scan-lines">
                    <div
                        class="scan-line"
                        *ngFor="let line of scanLines"
                        [class.off]="!line.included"
                        [class.returned]="line.gehtZurueck"
                    >
                        <mat-checkbox [(ngModel)]="line.included" matTooltip="Mitbuchen"></mat-checkbox>
                        <div class="scan-line__body">
                            <div class="scan-line__name">
                                <strong *ngIf="line.matched">{{ line.artikel }}</strong>
                                <strong *ngIf="!line.matched && line.artikel && !isOcrJunkName(line.artikel)">
                                    {{ line.artikel }}
                                </strong>
                                <span class="miss" *ngIf="!line.matched">Artikel wählen</span>
                                <span class="return-tag" *ngIf="line.gehtZurueck">Geht zurück – nicht buchen</span>
                                <span class="order-tag" *ngIf="line.bestellNr && !(line.orderOptions?.length > 1)">
                                    Best. {{ line.bestellNr }}
                                </span>
                                <button
                                    mat-icon-button
                                    type="button"
                                    class="scan-line__remove"
                                    matTooltip="Position entfernen"
                                    (click)="removeScanLine(line)"
                                >
                                    <mat-icon>delete_outline</mat-icon>
                                </button>
                            </div>
                            <mat-form-field *ngIf="line.orderOptions?.length > 1" class="scan-line__order">
                                <mat-label>Bestellung</mat-label>
                                <mat-select
                                    [(ngModel)]="line.bestellungExternId"
                                    (ngModelChange)="onLineOrderChange(line)"
                                >
                                    <mat-option [value]="null">ohne Bestellung</mat-option>
                                    <mat-option
                                        *ngFor="let o of line.orderOptions"
                                        [value]="o.bestellung_extern_id"
                                    >
                                        {{ o.bestell_nr }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <kiene-article-scan-autocomplete
                                [placeholder]="line.matched ? 'Anderen Artikel scannen' : 'Artikel scannen oder suchen'"
                                [focus]="false"
                                [captureShortcut]="false"
                                [labor]="laborWareneingang"
                                [presetMaterial]="scanLineMaterial(line)"
                                [debounceTimeMs]="80"
                                (selectedMaterial)="onScanLineScanned(line, $event)"
                            ></kiene-article-scan-autocomplete>
                            <div class="scan-line__fields">
                                <mat-form-field>
                                    <input matInput type="number" [(ngModel)]="line.menge" placeholder="Menge" />
                                    <span matSuffix *ngIf="line.mengeSoll != null">
                                        / Soll {{ line.mengeSoll }}
                                        <span *ngIf="isScanLineOverbook(line)" class="over-hint">überbucht</span>
                                    </span>
                                </mat-form-field>
                                <mat-form-field *ngIf="line.chargenpflichtig">
                                    <input matInput [(ngModel)]="line.charge" placeholder="Charge" required />
                                </mat-form-field>
                                <mat-form-field *ngIf="line.chargenpflichtig">
                                    <input
                                        matInput
                                        [matDatepicker]="mhdPicker"
                                        [(ngModel)]="line.mhd"
                                        placeholder="MHD"
                                        required
                                    />
                                    <mat-datepicker-toggle matSuffix [for]="mhdPicker"></mat-datepicker-toggle>
                                    <mat-datepicker #mhdPicker></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="scan-line__kind" *ngIf="line.artikelId > 0 && line.verbrauch != null">
                                <span class="scan-line__kind-label">{{
                                    line.verbrauch ? 'Verbrauch' : 'Umsatz'
                                }}</span>
                            </div>
                            <div class="scan-line__lager" *ngIf="line.included">
                                <div class="scan-line__lager-label">Lagerplatz</div>
                                <mat-chip-list [selectable]="true">
                                    <mat-chip
                                        *ngFor="let sps of line.lagerplatzSuggestions"
                                        [selectable]="true"
                                        [selected]="isLineStorageSelected(line, sps)"
                                        color="primary"
                                        style="cursor: pointer"
                                        (click)="setLineStoragePlace(line, sps)"
                                    >
                                        {{ sps.bezeichnung }}
                                    </mat-chip>
                                </mat-chip-list>
                                <kiene-autocomplete
                                    *ngIf="!istLaborWarenbestellung(scanOrderForLine(line))"
                                    [apiUrl]="'lagerplatz/'"
                                    [displayField]="'bezeichnung'"
                                    [kieneObject]="line.lagerplatz"
                                    [placeholder]="'Lagerplatz suchen'"
                                    [focus]="false"
                                    (elementSelected)="setLineStoragePlace(line, $event)"
                                ></kiene-autocomplete>
                            </div>
                        </div>
                    </div>
                </div>
                <button mat-stroked-button type="button" class="add-line-btn" (click)="addScanLine()">
                    <mat-icon>add</mat-icon>
                    Position hinzufügen
                </button>

                <div class="scan-actions" *kienePermission="[1652, 1082]">
                    <button mat-stroked-button type="button" (click)="clearScan()" [disabled]="scanSaving">
                        Abbrechen
                    </button>
                    <button
                        mat-raised-button
                        color="primary"
                        type="button"
                        [disabled]="!canSaveScan"
                        (click)="saveScanReceipt()"
                    >
                        Wareneingang buchen
                    </button>
                </div>
            </ng-container>
        </div>

        <aside class="order-pane" *ngIf="!scanning && !scanFailed && draft">
            <h4 class="pane-heading">Bestellung</h4>
            <div class="order-empty" *ngIf="!scanSelectedOrders.length && !scanOrdersLoading">
                <mat-icon>assignment</mat-icon>
                <p>Bestellung auswählen, um den Fortschritt zu sehen.</p>
            </div>
            <div class="order-loading" *ngIf="scanOrdersLoading">
                <mat-spinner diameter="28"></mat-spinner>
                <span>Bestellung wird geladen …</span>
            </div>
            <ng-container *ngIf="!scanOrdersLoading && scanSelectedOrders.length">
                <div class="order-card" *ngFor="let order of orderProgress">
                    <div class="order-card__head">
                        <div>
                            <strong>Bestellung {{ order.bestellNr }}</strong>
                            <div class="order-card__meta">
                                <span *ngIf="order.lieferant">{{ order.lieferant }}</span>
                                <span *ngIf="order.bestellt"> · {{ order.bestellt | date: 'dd.MM.yyyy' }}</span>
                            </div>
                        </div>
                        <span class="order-card__hits">
                            {{ order.hitCount }}/{{ order.positions.length }} Positionen
                        </span>
                    </div>
                    <div class="order-bar" [class.over]="order.over" [matTooltip]="formatQty(order.qtyPercent) + ' % der Bestellmenge'">
                        <div class="order-bar__fill" [style.width.%]="order.qtyPercent"></div>
                    </div>
                    <div class="order-pos-head">
                        <span>Artikel</span>
                        <span>Bestellt</span>
                        <span>Geliefert</span>
                        <span>Dieser WE</span>
                        <span>Offen</span>
                    </div>
                    <div class="order-pos" *ngFor="let p of order.positions" [ngClass]="p.state">
                        <span class="artikel" [title]="p.artikel">
                            {{ p.artikel }}
                            <small *ngIf="p.state === 'over'">überbucht</small>
                        </span>
                        <span>{{ formatQty(p.soll) }}</span>
                        <span>{{ formatQty(p.ist) }}</span>
                        <span class="we">{{ p.we ? formatQty(p.we) : '–' }}</span>
                        <span>{{ p.state === 'over' ? overbookLabel(p) : formatQty(p.offen > 0 ? p.offen : 0) }}</span>
                    </div>
                    <p class="order-empty-pos" *ngIf="!order.positions.length">Keine Positionen in dieser Bestellung.</p>
                </div>
                <div class="order-extra" *ngIf="extraScanLines.length">
                    <h4>Zusätzlich (nicht in der Bestellung)</h4>
                    <p class="hint">Zugeordnete Artikel, die auf keiner offenen Position stehen.</p>
                    <div class="order-pos extra" *ngFor="let line of extraScanLines">
                        <span class="artikel" [title]="line.artikel">
                            {{ line.matched ? line.artikel : 'nicht zugeordnet' }}
                        </span>
                        <span></span>
                        <span></span>
                        <span class="we">{{ formatQty(line.menge) }}</span>
                        <span></span>
                    </div>
                </div>
            </ng-container>
        </aside>
    </div>

    <mat-accordion *ngIf="!scanFile">
        <mat-expansion-panel class="manual-panel">
            <mat-expansion-panel-header>
                <mat-panel-title>Manuell ohne PDF</mat-panel-title>
                <mat-panel-description>Artikel scannen, Charge und MHD einzeln buchen</mat-panel-description>
            </mat-expansion-panel-header>

            <mat-card class="manual-card">
                <div>
                    <h4
                        >1. Material auswählen:
                        <span *ngIf="newMaterial && newMaterial.bezeichnung" class="kiene-color">{{
                            newMaterial.bezeichnung
                        }}</span>
                    </h4>

                    <div class="one-row">
                        <kiene-article-scan-autocomplete
                            #materialAutocomplete
                            (cleared)="clearInputs()"
                            (scannedEAN)="setProduktkennzeichnung($event)"
                            (selectedMaterial)="isArticleInDatabase($event)"
                            [focus]="false"
                            [labor]="laborWareneingang"
                            [placeholder]="'Material scannen oder manuell eintragen'"
                            style="width: inherit"
                        ></kiene-article-scan-autocomplete>
                        <button
                            (click)="openAddArticleDialog()"
                            color="primary"
                            mat-icon-button
                            style="padding-left: 15px; padding-bottom: 58px"
                        >
                            <mat-icon>add</mat-icon>
                        </button>
                    </div>
                    <div *ngIf="newMaterial?.bezeichnung && manualVerbrauch != null" class="scan-line__kind">
                        <span class="scan-line__kind-label">{{
                            manualVerbrauch ? 'Verbrauch' : 'Umsatz'
                        }}</span>
                    </div>
                    <br />
                    <mat-divider *ngIf="newMaterial?.bezeichnung"></mat-divider>
                    <div *ngIf="newMaterial?.bezeichnung && manualNeedsLot">
                        <h4>2. Charge eingeben</h4>
                        <mat-form-field style="min-width: 500px">
                            <input
                                [(ngModel)]="goodReceipt.charge"
                                aria-label="Charge"
                                matInput
                                placeholder="Charge"
                                required
                            />
                        </mat-form-field>
                    </div>
                    <br />
                    <mat-divider *ngIf="newMaterial?.bezeichnung && manualNeedsLot"></mat-divider>
                    <div *ngIf="newMaterial?.bezeichnung && manualNeedsLot">
                        <h4>3. MHD eingeben</h4>
                        <mat-form-field style="min-width: 500px">
                            <input
                                [(ngModel)]="goodReceipt.mhd"
                                [matDatepicker]="picker"
                                matInput
                                placeholder="MHD"
                                required
                            />
                            <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                    </div>
                </div>
                <br />
                <mat-divider *ngIf="goodReceipt?.mhd || (newMaterial?.bezeichnung && !manualNeedsLot)"></mat-divider>
                <div *ngIf="goodReceipt?.mhd || (newMaterial?.bezeichnung && !manualNeedsLot)">
                    <h4
                        >4. Lagerplatz auswählen:
                        <span *ngIf="selectedStoragePlace?.bezeichnung != ''" class="kiene-color">{{
                            selectedStoragePlace?.bezeichnung
                        }}</span>
                    </h4>
                    <mat-chip-list [selectable]="true">
                        <mat-chip
                            (click)="setSelectedStoragePlace(sps)"
                            *ngFor="let sps of storagePlaceSuggestions"
                            [selectable]="true"
                            [selected]="isStoragePlaceSelected(sps)"
                            color="primary"
                            >{{ sps?.bezeichnung }}
                        </mat-chip>
                        <button
                            (click)="showStoragePlaceAutocomplete = !showStoragePlaceAutocomplete"
                            *ngIf="storagePlaceSuggestions?.length > 0 && !nurLaborLagerplatz()"
                            color="primary"
                            mat-button
                            >...anderer Lagerplatz
                        </button>
                    </mat-chip-list>
                    <br />
                    <kiene-autocomplete
                        (elementSelected)="setSelectedStoragePlace($event)"
                        *ngIf="!nurLaborLagerplatz() && (showStoragePlaceAutocomplete == true || storagePlaceSuggestions?.length == 0)"
                        [apiUrl]="'lagerplatz/'"
                        [displayField]="'bezeichnung'"
                        [placeholder]="'Lagerplatz suchen'"
                    ></kiene-autocomplete>
                </div>

                <br />
                <mat-divider *ngIf="selectedStoragePlace?.bezeichnung"></mat-divider>
                <div *ngIf="selectedStoragePlace?.bezeichnung">
                    <h4>5. Passende Bestellung auswählen</h4>
                    <mat-chip-list>
                        <mat-chip
                            (click)="setSelectedOrder(po)"
                            *ngFor="let po of possibleBestellungen"
                            [selectable]="true"
                            [selected]="isOrderSelected(po)"
                            color="primary"
                            style="cursor: pointer"
                        >
                            {{ po?.bestell_nr }} {{ "(" + po?.lieferant + ")" }} vom
                            {{ po?.bestellt | date: "dd.MM.yyyy" }}
                        </mat-chip>
                    </mat-chip-list>
                </div>

                <br />
                <mat-divider *ngIf="selectedStoragePlace?.bezeichnung"></mat-divider>
                <div *ngIf="selectedStoragePlace?.bezeichnung">
                    <h4>6. Menge eingeben</h4>
                    <mat-form-field style="min-width: 500px">
                        <input
                            [(ngModel)]="goodReceipt.menge"
                            aria-label="Menge"
                            matInput
                            placeholder="Menge"
                            required
                            type="number"
                        />
                    </mat-form-field>
                </div>

                <mat-card-actions>
                    <div *kienePermission="[1652, 1082]">
                        <button
                            (click)="saveGoodReceipt()"
                            *ngIf="goodReceipt?.menge"
                            [disabled]="saveButtonDisabled"
                            color="primary"
                            mat-raised-button
                            >Speichern
                        </button>
                    </div>
                </mat-card-actions>
            </mat-card>
        </mat-expansion-panel>
    </mat-accordion>
</div>
